import { Alert, CircularProgress, Skeleton, Typography } from '@mui/material';
import { COLOURS_LIGHT, LINE_HEIGHT_REGULAR } from '../providers/designSystem';

export const Header = ({ children }) => {
    return (
        <header>
            <div className="content">{children}</div>
        </header>
    );
};

export const Main = ({ children }) => {
    return (
        <main>
            <div className="content">{children}</div>
        </main>
    );
};

export const Footer = ({ children }) => {
    return (
        <footer>
            <div className="content">{children}</div>
        </footer>
    );
};

export const Heading = ({ children }) => {
    return (
        <Typography variant="h1" textTransform="uppercase">
            {children}
        </Typography>
    );
};

export const SubHeading = ({ children }) => {
    return <Typography variant="h2">{children}</Typography>;
};

export const Text = ({ children }) => {
    return <Typography variant="body1">{children}</Typography>;
};

export const TextSpan = ({ children }) => {
    return (
        <Typography variant="body2" component="span">
            {children}
        </Typography>
    );
};

export const TextSubtle = ({ children }) => {
    return (
        <p
            style={{
                color: `${COLOURS_LIGHT.grey}`,
                fontSize: `12px`,
                lineHeight: `${LINE_HEIGHT_REGULAR}`,
            }}
        >
            {children}
        </p>
    );
};

export const Loading = () => {
    return <CircularProgress />;
};

export const Error = () => {
    return <p className="text-base text-gray-300">Something went wrong</p>;
};

export const LoadingBox = ({ width = '360px', height = '240px' }) => {
    return <Skeleton width={width} height={height} />;
};

export const ErrorMessage = ({ message = 'Something went wrong. Please try again.' }) => {
    return <Alert severity="error">{message}</Alert>;
};

export const SuccessMessage = ({ message }) => {
    return <Alert severity="success">{message}</Alert>;
};
